import React from 'react'
import { Button } from '@mui/material'
import { Popconfirm } from '../../../ui/index'
import { StopOutlined } from '../../../ui/icons'
import { tableListStatusToggleButtonSx } from '../tableList/tableListSizing'

export type StopActivateButtonProps = {
  active: boolean
  onStop?: () => void | Promise<void>
  onActivate?: () => void | Promise<void>
  disabled?: boolean
  stopConfirmTitle?: string
  activateConfirmTitle?: string
  stopLabel?: string
  activateLabel?: string
}

const StopActivateButton: React.FC<StopActivateButtonProps> = ({
  active,
  onStop,
  onActivate,
  disabled = false,
  stopConfirmTitle = 'Bạn chắc chắn muốn dừng?',
  activateConfirmTitle = 'Bạn chắc chắn muốn kích hoạt?',
  stopLabel = 'Dừng',
  activateLabel = 'Kích hoạt',
}) => {
  if (active) {
    return (
      <Popconfirm title={stopConfirmTitle} onConfirm={onStop} disabled={disabled}>
        <Button
          variant="contained"
          color="error"
          size="small"
          startIcon={<StopOutlined />}
          disabled={disabled}
          sx={tableListStatusToggleButtonSx}
        >
          {stopLabel}
        </Button>
      </Popconfirm>
    )
  }

  return (
    <Popconfirm title={activateConfirmTitle} onConfirm={onActivate} disabled={disabled}>
      <Button
        variant="contained"
        color="primary"
        size="small"
        disabled={disabled}
        sx={tableListStatusToggleButtonSx}
      >
        {activateLabel}
      </Button>
    </Popconfirm>
  )
}

export default StopActivateButton
